import { bl_sfa_sales_lead_entity_link_RowClass } from "../../../dbschema/bl_sfa_sales_lead_entity_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaSalesLeadEntityLinkContainerModel extends BaseContainerModel {
    bl_sfa_sales_lead_entity_link: bl_sfa_sales_lead_entity_link_RowClass = new bl_sfa_sales_lead_entity_link_RowClass()
}